import { useQuery } from "@tanstack/react-query";
import agentsService from "services/admin/AgentsService";

export const useGetAIAgents = (queryParams = {}) => {
    return useQuery({
        queryKey: ['ai-agents', queryParams],
        queryFn: async () => {
            const { data } = await agentsService.getAll(queryParams)
            return data
        },
        refetchOnWindowFocus: false,
    })
}